import React from 'react'
import Navbar from '../Components/Navbar'
import Intro from '../Components/About/Intro'
import Mission from '../Components/About/Mission'
import Why from '../Components/About/Why'
import Aboutdropdown from '../Components/About/Aboutdropdown'
import Footer from '../Components/Foooter'
import PageHero from '../Components/PageHero'
import PageSEO from '../Components/SEO/PageSEO'
import PersistentCTA from '../Components/CRO/PersistentCTA'
import StickyMobileCTA from '../Components/CRO/StickyMobileCTA'

const About = () => {
  return (
   <>
   <PageSEO 
     title="Best Digital Marketing & Web Development Ramamurthy Nagar"
     description="Cyborgsapient Pvt. Ltd. is a top digital marketing and web development company in Ramamurthy Nagar, helping businesses grow with SEO, PPC, and scalable websites."
     keywords="digital marketing web development ramamurthy nagar, best digital marketing company bangalore, web development company ramamurthy nagar"
     url="https://cyborgsapient.com/about"
   />
   <Navbar/>
   <PageHero 
     title="About **Us**"
     subtitle="Digital growth partners for modern businesses"
   />
   <Intro/>
   <Mission/>
   <Why/>
   <Aboutdropdown/>
   <Footer/>
   <PersistentCTA />
   <StickyMobileCTA />
   </>
  )
}

export default About
